export enum ModuleRotations {
  degree_0 = 0,
  degree_90 = 90,
  degree_180 = 180,
  degree_270 = 270
}
